import { AlertColor } from '@mui/material';
import { NotificationType } from 'components/Snackbar/types';

export const getAlertSeverity = (type?: NotificationType): AlertColor => {
  switch (type) {
    case NotificationType.SUCCESS:
      return 'success';
    case NotificationType.ERROR:
      return 'error';
    case NotificationType.WARNING:
      return 'warning';
    default:
      return 'info';
  }
};
